"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _modal = require("../../styles/modal");

var _ = require("../..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/*
    How to use: 
    <button onClick={()=>{setShowModal(!showModal);}}> Show me the Modal </button>
    <ConfirmCancelModal
        showModal={showModal}
        closeModal={()=>{setShowModal(false);}}
        closeOnBackgroundTouch={true} //optional
        title={'confirm'} //optional
        message={'Are you sure you want to remove this item from your shopping bag yada yada blah bidi blah blah? '}
        onConfirm={()=>{setShowModal(false);}}
        onCancel={()=>{setShowModal(false);}}
        okText={'Okurrrr'} //optional
        cancelText={'wagnabeh'} // optional
    />
*/


var ConfirmCancelModal = function ConfirmCancelModal(props) {
  var showModal = props.showModal,
      closeModal = props.closeModal,
      _props$closeOnBackgro = props.closeOnBackgroundTouch,
      closeOnBackgroundTouch = _props$closeOnBackgro === void 0 ? true : _props$closeOnBackgro,
      title = props.title,
      message = props.message,
      onConfirm = props.onConfirm,
      onCancel = props.onCancel,
      okText = props.okText,
      cancelText = props.cancelText,
      style = props.style,
      modalOverlay = props.modalOverlay,
      titleStyle = props.titleStyle,
      messageStyle = props.messageStyle,
      _props$hideCancelBtn = props.hideCancelBtn,
      hideCancelBtn = _props$hideCancelBtn === void 0 ? false : _props$hideCancelBtn;

  var ref = _react["default"].createRef();

  return showModal ? /*#__PURE__*/_react["default"].createElement(_modal.ModalBackground, {
    backgroundColor: modalOverlay,
    onClick: function onClick(e) {
      if (closeOnBackgroundTouch && e.target === ref.current) {
        closeModal();
      }
    },
    ref: ref,
    style: {
      backgroundColor: 'transparent'
    }
  }, /*#__PURE__*/_react["default"].createElement(_modal.ModalContainer, {
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_modal.ModalHeader, null, /*#__PURE__*/_react["default"].createElement(_modal.ModalTitle, {
    titleStyle: titleStyle
  }, title), /*#__PURE__*/_react["default"].createElement(_modal.CloseButton, {
    onClick: closeModal
  }, "\xD7")), /*#__PURE__*/_react["default"].createElement(_modal.ModalMessage, {
    messageStyle: messageStyle
  }, message), /*#__PURE__*/_react["default"].createElement(_modal.ModalFooter, null, /*#__PURE__*/_react["default"].createElement(_.RoundedButton, {
    primary: true,
    onClick: onConfirm
  }, okText || "OK"), !hideCancelBtn && /*#__PURE__*/_react["default"].createElement(_.RoundedButton, {
    onClick: onCancel,
    style: {
      background: "#E7E3E6",
      borderColor: "#E7E3E6"
    }
  }, cancelText || "Cancel")))) : /*#__PURE__*/_react["default"].createElement("div", null);
};

var _default = ConfirmCancelModal;
exports["default"] = _default;
module.exports = exports["default"];